// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"19372234","127":"a19f3d18","148":"39a72f59","309":"8b47feb9","394":"631c6bda","453":"0c3eeb6e","490":"907b098a","561":"da8b9f29","697":"6259e330","737":"094abe58","899":"a7555436"}[chunkId] + ".chunk.js";
};